import { Stack, useWindowProperties } from '@qred/components-library';
import React, { RefObject } from 'react';
import { isInIframe } from '~/iframeMode';
import { StepConfigItem } from '~/Interfaces';
import { StepFooterWrapper } from '../Stepper.styled';
import NextButton from './NextButton';

interface StepFooterProps {
  CTALabel: string;
  currentStepConfig: StepConfigItem;
  CTAAction: () => void;
  footerRef: RefObject<HTMLDivElement>;
  stepIsLoading?: boolean;
  extraContent?: React.ReactNode;
  extraFooterContentOptions?: {
    align?: 'above-cta' | 'below-cta';
  };
  fixedFooter?: boolean;
}

const StepFooter = ({
  CTALabel,
  currentStepConfig,
  CTAAction,
  footerRef,
  stepIsLoading,
  extraContent,
  extraFooterContentOptions = { align: 'above-cta' },
  fixedFooter,
}: StepFooterProps) => {
  const { isMobile } = useWindowProperties();

  return (
    <StepFooterWrapper
      ref={footerRef}
      $fixedFooter={fixedFooter}
      $isInIframe={isInIframe}
    >
      <Stack
        justify={'center'}
        align={'center'}
        spacing={isMobile ? 'sm' : 'xs'}
        w="100%"
      >
        {extraFooterContentOptions.align === 'above-cta' && extraContent}
        {currentStepConfig.customFooter ? (
          <currentStepConfig.customFooter />
        ) : (
          <NextButton
            label={CTALabel}
            action={CTAAction}
            isLoading={stepIsLoading}
          />
        )}
        {extraFooterContentOptions.align === 'below-cta' && extraContent}
      </Stack>
    </StepFooterWrapper>
  );
};

export default StepFooter;
